import { render } from "./StampClock.vue?vue&type=template&id=0f55b1ea&scoped=true"
import script from "./StampClock.vue?vue&type=script&lang=js"
export * from "./StampClock.vue?vue&type=script&lang=js"

import "./StampClock.vue?vue&type=style&index=0&id=0f55b1ea&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f55b1ea"]])

export default __exports__